module.exports = __webpack_public_path__ + "static/img/supper.abd45fe2.png";